import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import { BrandsFromTickerSymbols } from "@tiicker/util/lib/contentful/queries";
import {
  BrandDetailDocument,
  ContentfulContentType,
} from "@tiicker/util/lib/contentful/types";
import Link from "next/link";
import React from "react";
import { useContentfulEntries } from "source/contentful/provider";
import styles from "./RecommendedBrandsV2.module.scss";

interface Props {
  centeredHeading?: boolean;
  tickerSymbols: string[];
}

const RecommendedBrands = (props: Props) => {
  const brands = useContentfulEntries<BrandDetailDocument>(
    ContentfulContentType.BrandDetail,
    {
      query: BrandsFromTickerSymbols(props.tickerSymbols),
    }
  );

  if (brands.state !== "DONE") {
    return <></>;
  }

  return brands.result.items.length > 0 ? (
    <div className={styles.recommendedBrands}>
      <h3 className={styles.recommendedBrands__heading}>Recommended for you</h3>
      <div className={styles.recommendedBrands__grid}>
        {brands.result.items.map((brandDetail) => {
          const heroImage = getImageReference(
            brandDetail.fields.heroImage,
            brands.result.includes
          );
          return (
            <Link
              href="/brand/[symbol]"
              as={`/brand/${brandDetail.fields.tickerSymbol}`}
            >
              <a className={styles.recommendedBrands__gridItem}>
                <img
                  className={styles.recommendedBrands__gridItemImage}
                  src={heroImage?.fields.file.url}
                />
                <div className={styles.recommendedBrands__gridItemText}>
                  <h4 className={styles.recommendedBrands__gridItemTitle}>
                    {brandDetail.fields.brandName}
                    <span className={styles.recommendedBrands__gridItemSymbol}>
                      {brandDetail.fields.tickerSymbol}
                    </span>
                  </h4>
                </div>
              </a>
            </Link>
          );
        })}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default RecommendedBrands;
